import { render, staticRenderFns } from "./InvalidData.vue?vue&type=template&id=6061a105"
import script from "./InvalidData.vue?vue&type=script&lang=js"
export * from "./InvalidData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports